import React from 'react';
import { Monitor } from 'lucide-react';
export function MobileUnsupported() {
  return <div className="md:hidden fixed inset-0 bg-[#F1F5F9] z-[9999] flex items-center justify-center p-6" data-id="element-1821">
      <div className="max-w-md text-center" data-id="element-1822">
        <div className="mb-6 flex justify-center" data-id="element-1823">
          <div className="w-20 h-20 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-1824">
            <Monitor className="w-10 h-10 text-[#0EA5E9]" data-id="element-1825" />
          </div>
        </div>
        <h1 className="text-[24px] font-semibold text-[#0F172A] mb-3" data-id="element-1826">
          Desktop or Tablet Required
        </h1>
        <p className="text-[14px] text-[#64748B] mb-6 leading-relaxed" data-id="element-1827">
          This application is optimized for desktop and tablet devices. Please
          use a larger screen for the best experience.
        </p>
        <div className="bg-white rounded-lg border border-[#E2E8F0] p-4 shadow-sm" data-id="element-1828">
          <p className="text-[13px] text-[#475569] font-medium mb-2" data-id="element-1829">
            For the best experience:
          </p>
          <ul className="text-[13px] text-[#64748B] text-left space-y-1.5" data-id="element-1830">
            <li data-id="element-1831">• Use a tablet (768px or wider)</li>
            <li data-id="element-1832">• Use a desktop computer</li>
            <li data-id="element-1833">• Rotate your device to landscape</li>
          </ul>
        </div>
      </div>
    </div>;
}